import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-visitor-agreement',
  imports: [CommonModule],
  templateUrl: './visitor-agreement.component.html',
  styleUrl: './visitor-agreement.component.scss',
})
export class VisitorAgreementComponent {
  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData(): void {
    const title = `Visitor Agreement | Only Used Tesla`;
    const description = `Visitor Agreement | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas.`;
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/visitor-agreement';

    // Assuming you have a service to set meta data
    this.seoService.setMetaData(title, description, imageUrl, url);
  }

}
